import apiClient from "./apiClient"
import type { McoEndpointBuilder } from "./apiSlice"
import { ApiTag } from "./util/ApiTag"

const professionalEndpoints = (build: McoEndpointBuilder) => ({
	professionalFilters: build.query({
		queryFn: (_: void) => apiClient.professional.getFilters(),
		providesTags: [ApiTag.Tenant] // Not adding Professional tag as don't want to constantly be refetching when little will change as request is expensive
	}),
	professionalSearch: build.query({
		queryFn: apiClient.professional.search,
		providesTags: [ApiTag.Tenant] // Not adding Professional tag as don't want to constantly be refetching when little will change as request is expensive
	})
})

export default professionalEndpoints
